import type { Translate } from "next-translate";

export const NAMESPACE = "validations";
export const DOMAIN_VALIDATIONS = "validations";

type ValidationArgs = object;

export const LocaleValidations = (t: Translate) => ({
  mixed: {
    default: (args: ValidationArgs) => t(`${NAMESPACE}:mixed.default`, args),
    required: (args: ValidationArgs) => t(`${NAMESPACE}:mixed.required`, args),
    imageDimensions: (args: ValidationArgs) => t(`${NAMESPACE}:mixed.imageDimensions`, args),
    imageType: (args: ValidationArgs) => t(`${NAMESPACE}:mixed.imageType`, args),
  },
  string: {
    length: (args: ValidationArgs) => t(`${NAMESPACE}:string.length`, args),
    min: (args: ValidationArgs) => t(`${NAMESPACE}:string.min`, args),
    max: (args: ValidationArgs) => t(`${NAMESPACE}:string.max`, args),
    matches: (args: ValidationArgs) => t(`${NAMESPACE}:string.matches`, args),
    email: (args: ValidationArgs) => t(`${NAMESPACE}:string.email`, args),
    trim: (args: ValidationArgs) => t(`${NAMESPACE}:string.trim`, args),
    lowercase: (args: ValidationArgs) => t(`${NAMESPACE}:string.lowercase`, args),
    uppercase: (args: ValidationArgs) => t(`${NAMESPACE}:string.uppercase`, args),
  },
  number: {
    min: (args: ValidationArgs) => t(`${NAMESPACE}:number.min`, args),
    max: (args: ValidationArgs) => t(`${NAMESPACE}:number.max`, args),
    lessThan: (args: ValidationArgs) => t(`${NAMESPACE}:number.lessThan`, args),
    moreThan: (args: ValidationArgs) => t(`${NAMESPACE}:number.moreThan`, args),
    positive: (args: ValidationArgs) => t(`${NAMESPACE}:number.positive`, args),
    negative: (args: ValidationArgs) => t(`${NAMESPACE}:number.negative`, args),
  },
  date: {
    min: (args: ValidationArgs) => t(`${NAMESPACE}:date.min`, args),
    max: (args: ValidationArgs) => t(`${NAMESPACE}:date.max`, args),
  },
  boolean: {
    isValue: (args: ValidationArgs) => t(`${NAMESPACE}:boolean.isValue`, args),
  },
  object: {
    noUnknown: (args: ValidationArgs) => t(`${NAMESPACE}:object.noUnknown`, args),
  },
  array: {
    min: (args: ValidationArgs) => t(`${NAMESPACE}:array.min`, args),
    max: (args: ValidationArgs) => t(`${NAMESPACE}:array.max`, args),
    length: (args: ValidationArgs) => t(`${NAMESPACE}:array.length`, args),
  },
});
